import { createSlice, createAsyncThunk, original } from '@reduxjs/toolkit';
import { HTTP_GETTYPE, STATUS_API } from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';
import { _convertObjectToQuery } from 'src/app/utils/apiService';
import axios from '../app/axiosInterceptor';

//api search man giam sat
export const getListVehicle = AxiosAdapter.GetHttp(
  'vehicleSlice/GetListVehicles',
  '/vehicles',
  HTTP_GETTYPE.ALL_PAGINATION
);

//ap get list xe view map
export const getListVehicleTrackingById = AxiosAdapter.HttpGetById(
  'vehicleSlice/GetListVehiclesTrackingById',
  '/vehicles/tracking/agency'
);

export const getListVehicleTrackingByUserId = AxiosAdapter.HttpGetById(
  'vehicleSlice/GetListVehiclesTrackingByUser',
  '/vehicles/tracking/endUser'
);

export const getListVehiclesTrackingByDriver = AxiosAdapter.GetHttp(
  'vehicleSlice/GetListVehiclesTrackingByDriver',
  '/vehicles/tracking/sub-account',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getDetailVehicle = AxiosAdapter.HttpGetById(
  'vehicleSlice/GetDetailVehicle',
  '/vehicles/detail'
);

export const getVehicleLicensePlate = AxiosAdapter.GetHttp(
  'vehicleSlice/GetVehicleLicensePlate',
  '/vehicles/license_plate',
  HTTP_GETTYPE.DETAIL
);

export const getVehicleLicensePlateCamera = AxiosAdapter.GetHttp(
  'vehicleSlice/GetVehicleLicensePlateCamera',
  '/vehicles/license_plate/camera',
  HTTP_GETTYPE.DETAIL
);

export const getVehicleSystemStatus = AxiosAdapter.HttpGetById(
  'vehicleSlice/GetVehicleSystemStatus',
  '/vehicles/tracking/latest/info/status',
);

export const exportExcelTrackingStatus = createAsyncThunk(
  'vehicleSlice/exportExcelTrackingStatus',
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const queryString = _convertObjectToQuery(data);

      const response = await axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/excel/tracking/status/${id}?${queryString}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        },
        responseType: 'blob'
      });

      // Tạo blob và download file
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tracking_status_sheet.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);

export const vehicleSlice = createSlice({
  name: 'vehicleSlice',
  initialState: {
    listVehicle: [],
    listLicensePlate: [],
    listLicensePlateCamera: [],
    listVehicleSystemStatus: [],
    totalVehicle: 0,
    errorGetList: null,
    errGetListLicensePlate: null,
    errGetListLicensePlateCamera: null,
    statusGetListVehicle: null,
    centerMap: { lat: 20.983173, lng: 105.766006 },

    agencySelected: null,
    listVehicleTracking: [],
    statisticVehicleTracking: null, // so luong cac xe o moi loai dung do
    statisticVehicleStatus: null, // so luong cac xe o moi loai WEBSOCKET

    totalVehicleTracking: 0,
    errorListTracking: null,
    statusGetListTracking: null,
    statusGetListLicensePlate: null,
    statusGetListLicensePlateCamera: null,

    err: null,
    detailVehicle: null,
    statusGetDetail: null,
    userSelected: null,
    selectedLicensePlate: null,
    existLincesePlate: true,
    positionsVehicle: null,
    isLoading: true
  },

  reducers: {
    setListVehicleTracking: (state, action) => {
      state.listVehicleTracking = action.payload;
    },
    // Nạp dần từng trang thiết bị (lazy-load cây đại lý) mà không xoá phần đã vẽ trên map.
    appendListVehicleTracking: (state, action) => {
      const incoming = action.payload || [];
      if (incoming.length === 0) return;

      const seen = new Set(state.listVehicleTracking.map(v => v.device_id));
      incoming.forEach(v => {
        if (seen.has(v.device_id)) return;
        seen.add(v.device_id);
        state.listVehicleTracking.push(v);
      });
    },
    // Payload chỉ gồm các xe vừa đổi. Tra chỉ số trên mảng GỐC (original) để immer chỉ tạo
    // draft cho đúng những xe cần sửa: xe không đổi giữ nguyên reference, thứ tự nạp giữ nguyên.
    mergeVehicleTracking: (state, action) => {
      const updates = action.payload || [];
      if (updates.length === 0) return;

      const base = original(state.listVehicleTracking) || [];
      const indexById = new Map();
      for (let i = 0; i < base.length; i += 1) {
        indexById.set(base[i].device_id, i);
      }

      updates.forEach(updatedVehicle => {
        const index = indexById.get(updatedVehicle.device_id);
        if (index !== undefined) {
          Object.assign(state.listVehicleTracking[index], updatedVehicle);
        }
      });
    },
    setStatisticVehicleStatus: (state, action) => {
      state.statisticVehicleStatus = action.payload;
    },
    setUserSelected: (state, action) => {
      state.userSelected = action.payload;
    },

    setSelectedLicensePlate: (state, action) => {
      state.selectedLicensePlate = action.payload;
    },

    setCenterMap: (state, action) => {
      state.centerMap = action.payload;
    },

    setExistLincesePlate: (state, action) => {
      state.selectedLicensePlate = action.payload;
    },

    setGetListLoading: (state, action) => {
      state.statusGetListTracking = action.payload;
    },

    resetListVehicle: (state, action) => {
      state.listVehicle = [];
      state.totalVehicle = 0;
      state.statusGetListVehicle = null;
      state.listVehicleTracking = [];
      state.statisticVehicleTracking = null;
    },

    resetChange: state => {
      state.statusGetListVehicle = null;
      state.statusGetDetail = null;
      state.userSelected = null;
      state.selectedLicensePlate = null;
      state.isLoading = false;
    }
  },

  extraReducers: {
    // Get list vehicles
    [getListVehicle.pending]: state => {
      state.statusGetListVehicle = STATUS_API.PENDING;
    },

    [getListVehicle.fulfilled]: (state, action) => {
      state.statusGetListVehicle = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.data;
      state.totalVehicle = action.payload.payload.total;
    },

    [getListVehicle.rejected]: (state, action) => {
      state.statusGetListVehicle = STATUS_API.ERROR;
      state.errorGetList = action.payload?.message || action.error;
    },

    // Get list tracking by id
    [getListVehicleTrackingById.pending]: state => {
      state.isLoading = true;
      state.statisticVehicleTracking = null;
      state.statusGetListTracking = STATUS_API.PENDING;
    },

    [getListVehicleTrackingById.fulfilled]: (state, action) => {
      state.statusGetListTracking = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.latest_periodics;
      state.statisticVehicleTracking = action.payload.payload.statistic;
      state.isLoading = false;
      state.totalVehicleTracking = action.payload.payload.length;
    },

    [getListVehicleTrackingById.rejected]: (state, action) => {
      state.statusGetListTracking = STATUS_API.ERROR;
      state.errorListTracking = action.payload?.message || action.error;
      state.isLoading = false;
    },

    // Get list tracking by user id (end user)
    [getListVehicleTrackingByUserId.pending]: state => {
      state.isLoading = true;
      state.listVehicleTracking = [];
      state.statisticVehicleTracking = null;
      state.statusGetListTracking = STATUS_API.PENDING;
      state.totalVehicleTracking = 0;
    },

    [getListVehicleTrackingByUserId.fulfilled]: (state, action) => {
      state.statusGetListTracking = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.latest_periodics;
      state.statisticVehicleTracking = action.payload.payload.statistic;
      state.isLoading = false;
      state.totalVehicleTracking = action.payload.payload.length;
    },
    [getListVehicleTrackingByUserId.rejected]: (state, action) => {
      state.statusGetListTracking = STATUS_API.ERROR;
      state.errorListTracking = action.payload?.message || action.error;
      state.isLoading = false;
    },

    // Get list tracking by driver id
     [getListVehiclesTrackingByDriver.pending]: state => {
      state.isLoading = true;
      state.listVehicleTracking = [];
      state.statisticVehicleTracking = null;
      state.statusGetListTracking = STATUS_API.PENDING;
      state.totalVehicleTracking = 0;
    },

    [getListVehiclesTrackingByDriver.fulfilled]: (state, action) => {
      state.statusGetListTracking = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.latest_periodics;
      state.statisticVehicleTracking = action.payload.payload.statistic;
      state.isLoading = false;
      state.totalVehicleTracking = action.payload.payload.length;
    },
    [getListVehiclesTrackingByDriver.rejected]: (state, action) => {
      state.statusGetListTracking = STATUS_API.ERROR;
      state.errorListTracking = action.payload?.message || action.error;
      state.isLoading = false;
    },

    //Get list license plate
    [getVehicleLicensePlate.pending]: state => {
      state.statusGetListLicensePlate = STATUS_API.PENDING;
    },
    [getVehicleLicensePlate.fulfilled]: (state, action) => {
      state.statusGetListLicensePlate = STATUS_API.SUCCESS;
      state.listLicensePlate = action.payload.payload.result.result;
    },
    [getVehicleLicensePlate.rejected]: (state, action) => {
      state.statusGetListLicensePlate = STATUS_API.ERROR;
      state.errGetListLicensePlate = action.payload?.message || action.error;
    },

    //Get list license plate camera
    [getVehicleLicensePlateCamera.pending]: state => {
      state.statusGetListLicensePlateCamera = STATUS_API.PENDING;
    },
    [getVehicleLicensePlateCamera.fulfilled]: (state, action) => {
      state.statusGetListLicensePlateCamera = STATUS_API.SUCCESS;
      const result = action.payload?.payload?.result;
      state.listLicensePlateCamera = Array.isArray(result) ? result : [];
    },
    [getVehicleLicensePlateCamera.rejected]: (state, action) => {
      state.statusGetListLicensePlateCamera = STATUS_API.ERROR;
      state.errGetListLicensePlateCamera =
        action.payload?.message || action.error;
      state.listLicensePlateCamera = [];
    },

    //Get Detail vehicle
    [getDetailVehicle.pending]: state => {
      state.statusGetDetail = STATUS_API.PENDING;
      state.err = null;
      state.detailVehicle = null;
    },
    [getDetailVehicle.fulfilled]: (state, action) => {
      state.statusGetDetail = STATUS_API.SUCCESS;
      state.detailVehicle = action.payload.payload.vehicle;
    },
    [getDetailVehicle.rejected]: (state, action) => {
      state.statusGetDetail = STATUS_API.ERROR;
      state.errorGetList = action.payload?.message || action.error;
    },

    [getVehicleSystemStatus.pending]: state => {
      state.err = null;
    },
    [getVehicleSystemStatus.fulfilled]: (state, action) => {
      state.listVehicleSystemStatus = action.payload.payload.latest_periodics;
    },
    [getVehicleSystemStatus.rejected]: (state, action) => {
      state.err = action.payload?.message || action.error;
    },

    // Export Excel Tracking Status
    [exportExcelTrackingStatus.pending]: state => {
      state.err = null;
    },
    [exportExcelTrackingStatus.fulfilled]: () => {
      // Success - file downloaded
    },
    [exportExcelTrackingStatus.rejected]: (state, action) => {
      state.err = action.payload?.message || action.error;
    }
  }
});
export const {
  resetChange,
  setCenterMap,
  setUserSelected,
  setSelectedLicensePlate,
  setExistLincesePlate,
  setGetListLoading,
  mergeVehicleTracking,
  setListVehicleTracking,
  appendListVehicleTracking,
  setStatisticVehicleStatus,
  resetListVehicle
} = vehicleSlice.actions;

export default vehicleSlice.reducer;
